/**
 * Roster fixo da base de conhecimento da Contestação (ids + nomes).
 * - mocks/knowledge-base monta as entidades completas (Tag, Fact, LegalRequest, Thesis, Topic) a partir daqui.
 * - mocks/contestacao usa os MESMOS ids/nomes nas revisões e nos templates (seções → tópicos → teses).
 */

export const MOCK_TAG_ROSTER = [
	{ id: 'tag-001', name: 'Jornada de trabalho' },
	{ id: 'tag-002', name: 'Verbas rescisórias' },
	{ id: 'tag-003', name: 'Danos morais' },
	{ id: 'tag-004', name: 'Prescrição' },
	{ id: 'tag-005', name: 'Saúde e segurança' },
	{ id: 'tag-006', name: 'Vínculo empregatício' },
] as const;

export const MOCK_TOPIC_ROSTER = [
	{ id: 'topic-001', name: 'Preliminares', enableBatchApproval: false },
	{ id: 'topic-002', name: 'Prejudiciais de mérito', enableBatchApproval: false },
	{ id: 'topic-003', name: 'Jornada de trabalho', enableBatchApproval: true },
	{ id: 'topic-004', name: 'Verbas rescisórias', enableBatchApproval: true },
	{ id: 'topic-005', name: 'Danos morais', enableBatchApproval: false },
	{ id: 'topic-006', name: 'Honorários e custas', enableBatchApproval: true },
] as const;

export const MOCK_FACT_ROSTER = [
	{ id: 'fact-001', slug: 'data-admissao', name: 'Data de admissão', classification: 'ALEGACAO' },
	{ id: 'fact-002', slug: 'data-demissao', name: 'Data de demissão', classification: 'ALEGACAO' },
	{ id: 'fact-003', slug: 'jornada-alegada', name: 'Jornada alegada', classification: 'ALEGACAO' },
	{
		id: 'fact-004',
		slug: 'possui-cartao-ponto',
		name: 'Possui cartões de ponto',
		classification: 'SUBSIDIO',
	},
	{
		id: 'fact-005',
		slug: 'motivo-rescisao',
		name: 'Motivo da rescisão',
		classification: 'ALEGACAO',
	},
	{ id: 'fact-006', slug: 'trct-assinado', name: 'TRCT assinado', classification: 'SUBSIDIO' },
	{
		id: 'fact-007',
		slug: 'foto-local-trabalho',
		name: 'Foto do local de trabalho',
		classification: 'IMAGEM',
	},
] as const;

export const MOCK_LEGAL_REQUEST_ROSTER = [
	{ id: 'lr-001', name: 'Horas extras e reflexos' },
	{ id: 'lr-002', name: 'Adicional noturno' },
	{ id: 'lr-003', name: 'Multa do art. 477 da CLT' },
	{ id: 'lr-004', name: 'Indenização por danos morais' },
	{ id: 'lr-005', name: 'Honorários advocatícios' },
] as const;

export const MOCK_THESIS_ROSTER = [
	{
		id: 'thesis-001',
		topicId: 'topic-001',
		name: 'Inépcia da inicial por pedido genérico',
		tipo: 'PRELIMINAR',
		tagIds: ['tag-001'],
		legalRequestIds: [],
	},
	{
		id: 'thesis-002',
		topicId: 'topic-002',
		name: 'Prescrição quinquenal',
		tipo: 'PRELIMINAR',
		tagIds: ['tag-004'],
		legalRequestIds: ['lr-001', 'lr-002'],
	},
	{
		id: 'thesis-003',
		topicId: 'topic-003',
		name: 'Validade dos cartões de ponto',
		tipo: 'MERITO',
		tagIds: ['tag-001'],
		legalRequestIds: ['lr-001'],
	},
	{
		id: 'thesis-004',
		topicId: 'topic-003',
		name: 'Compensação de jornada por banco de horas',
		tipo: 'MERITO',
		tagIds: ['tag-001'],
		legalRequestIds: ['lr-001'],
	},
	{
		id: 'thesis-005',
		topicId: 'topic-003',
		name: 'Inexistência de labor noturno',
		tipo: 'MERITO',
		tagIds: ['tag-001'],
		legalRequestIds: ['lr-002'],
	},
	{
		id: 'thesis-006',
		topicId: 'topic-004',
		name: 'Pagamento tempestivo das verbas rescisórias',
		tipo: 'MERITO',
		tagIds: ['tag-002'],
		legalRequestIds: ['lr-003'],
	},
	{
		id: 'thesis-007',
		topicId: 'topic-004',
		name: 'Quitação pelo TRCT homologado',
		tipo: 'MERITO',
		tagIds: ['tag-002'],
		legalRequestIds: ['lr-003'],
	},
	{
		id: 'thesis-008',
		topicId: 'topic-005',
		name: 'Ausência de prova do dano moral',
		tipo: 'MERITO',
		tagIds: ['tag-003'],
		legalRequestIds: ['lr-004'],
	},
	{
		id: 'thesis-009',
		topicId: 'topic-005',
		name: 'Valor excessivo da indenização (art. 223-G)',
		tipo: 'MERITO',
		tagIds: ['tag-003'],
		legalRequestIds: ['lr-004'],
	},
	{
		id: 'thesis-010',
		topicId: 'topic-006',
		name: 'Improcedência dos honorários sucumbenciais',
		tipo: 'MERITO',
		tagIds: [],
		legalRequestIds: ['lr-005'],
	},
] as const;
